var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("section-title", {
          attrs: {
            "container-class": "tag-badge-main-info mt-4 mb-4",
            content: "V. Resultados de Evaluaciones",
            icon: "fas fa-clipboard-list-check"
          }
        }),
        _vm._l(_vm.model.instruments, function(item) {
          return _c(
            "div",
            { key: item.id },
            [
              _c("result-row", {
                attrs: { "is-read-only": _vm.isReadOnly, item: item }
              })
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }